import React from 'react';

const X = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        viewBox="0 0 28 24.889"
    >
        <path
            fill="currentColor"
            d="M22.051 0h4.294l-9.38 10.543L28 24.89h-8.64l-6.767-8.702-7.744 8.702H.553l10.035-11.276L0 0h8.858l6.118 7.953L22.05 0Zm-1.507 22.361h2.379L7.567 2.395H5.014l15.53 19.966Z"
        />
    </svg>
);

export default X;
